import { PaymentTypes } from '@/api/klip-api.proxy';
import { useUserStore } from '@/app/shared/state/UserDataModule';
import { EUserRole } from '@/app/shared/state/user-role';
import { ISettingsView } from '@/api/klip-api.proxy';
import { useSettingsStore } from './settings-store';
import { computed, defineComponent, onBeforeMount, onMounted, ref } from 'vue';
import { useMetaStore } from '@/stores/meta-store';
import {useRoute, useRouter} from '@/router/router-vue3';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'SettingsOverview',
    props: {},
    setup(props) {
        const route = useRoute();
        const router = useRouter();

        const profileCardSubtitle: string = `Bent u dit niet? <a href="/auth/logout">Meld u af</a>.`;

        const error = ref<boolean>(false);
        const lastActiveTab = ref<string>('');

        const viewModel = computed((): ISettingsView => useSettingsStore().settingsView);
        const _fetchSettings = () => useSettingsStore().fetchSettings();

        const viewModelLoaded = computed((): boolean => {
            return !!viewModel.value;
        });

        const loading = computed(() => {
            if (!showTabs.value) {
                return false;
            }
            return !viewModelLoaded.value;
        });

        const profileCardTitle = computed(() => {
            return `${useUserStore().fullName}${useUserStore().user.organisation ? ` - ${useUserStore().user.organisation}` : ''}`;
        });

        const showContactSettings = computed(() => {
            return useUserStore().hasRole([EUserRole.mri]);
        });

        const showOrganisationSettings = computed(() => {
            return useUserStore().hasRole([EUserRole.mri, EUserRole.org_manager, EUserRole.una_manager, EUserRole.una_operator, EUserRole.una_reader, EUserRole.klim_admin]) && useUserStore().user.isCitizen === false;
        });

        const showInvoiceSettings = computed(() => {
            return useUserStore().hasRole([EUserRole.mri]) && !useUserStore().user.isCitizen && useUserStore().paymentType === PaymentTypes.Invoice;
        });

        const showTab = (tabName: string): boolean => {
            if (!showTabs.value && showOrganisationSettings.value) {
                return true;
            }
            return lastActiveTab.value === tabName;
        };

        const showTabs = computed(() => {
            return showContactSettings.value && showOrganisationSettings.value;
        });

        const wrapperComponent = computed(() => {
            return showTabs.value ? 'vl-tabs' : 'div';
        });

        const sectionComponent = computed(() => {
            return showTabs.value ? 'vl-tab' : 'div';
        });


        const tabChange = (tab: { id?: string }) => {
            if (tab && tab.id && lastActiveTab.value !== tab.id) {
                lastActiveTab.value = tab.id;
            }
        }


        onBeforeMount(() => {
            useMetaStore().setPageTitle("Instellingen");
        });

        onMounted(async () => {
            // Je kan naar deze pagina vanuit een email navigeren, en mogelijks is de userdata dan nog niet ingeladen. Vandaar de extra check, om zeker te zijn dat we alles correct tonen
            useUserStore().updateUserProfile().then(async () => {
                const shouldLoad = showOrganisationSettings.value || showContactSettings.value;
                if (!viewModelLoaded.value && shouldLoad) {
                    await _fetchSettings();
                }
            });
        });

        return {
            profileCardSubtitle,
            error,
            lastActiveTab,
            viewModel,
            viewModelLoaded,
            loading,
            profileCardTitle,
            showContactSettings,
            showOrganisationSettings,
            showTab,
            showTabs,
            showInvoiceSettings,
            wrapperComponent,
            sectionComponent,
            tabChange
        };
    }
})
